import 'moment/locale/id';
import React from 'react';
import { MdSearch as IconSearch } from 'react-icons/md';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button as ButtonReact, Form, FormGroup, Input, InputGroup, InputGroupAddon } from 'reactstrap';
import { bindActionCreators } from 'redux';
import { actions as notificationActions } from '../../redux/ducks/notification'
import { actions as modalActions } from '../../redux/ducks/modal'
import { buildWBoundActions, buildWSelector } from '../../redux/ducks'
import { SubViewHeader } from '../../lib/components/subHeader';
import { TagTable } from '../../custom/table';
import { SizeMe } from 'react-sizeme';
import { safeDeepGet, safeDeepGetWithType } from 'iotera-base/json';

/* Material-ui */
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

/* Tooltip */
import Tooltip from '@material-ui/core/Tooltip';
import Zoom from '@material-ui/core/Zoom';

/* Routes */
import { domainIsTenant, S } from '../../routes/routes'

import Loader from 'react-loader-advanced';
import ReactLoading from 'react-loading';
import Result from 'iotera-base/result';
import { TAG_CAT_SINGLE_SELECTION } from '../../lib/components/Preference';
import { isContainUppercase, hasWhiteSpace } from '../../lib/function';
import IoteraClass from '../../lib/components/react/react-class';
import { setCallbackGlobal, unsetCallbackGlobal } from '../../lib/components/callbackGlobal';

const INIT_TAGS = "INIT_TAGS";
const ADD = "ADD_TAG_DEF";
const RELOAD = 'RELOAD';
const WKEY = "TAG_LIST";
const wSelector = buildWSelector(WKEY);
const wBoundActions = buildWBoundActions(WKEY);

class TagList extends IoteraClass {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      filter: false,
      searchFilter: false,
      tagList: props.data,
      filters: {
        assigner: [],
        dueDate: [],
        tags: [],
        status: []
      },
      custom: window.innerWidth <= 768 ? "col-md-6" : "col-md-5"
    }
    this.resize = this.resize.bind(this);
    this.finalData = this.finalData.bind(this);
  }

  finalData(search, filter) {
    const _this = this;
    const _props = _this.props
    const _state = _this.state
    const allTag = _props.data;
    let tagToShow = [];
    allTag.forEach((tag) => {
      let foundTag = (search === '') ||
        ((tag.name.search(search)) !== -1) ||
        ((tag.prefix.search(search)) !== -1)
      if (foundTag) {
        tagToShow.push(tag)
      }
    })
    return tagToShow;
  }

  resize(event) {
    this.setState({
      custom: window.innerWidth <= 768 ? "col-md-6" : "col-md-5"
    })
  }

  handleChange = event => {
    this.setState({ search: event.target.value })
  }

  handleKeyUp = event => {
    const _this = this;
    const _state = _this.state
    if (event.key === "Enter") {
      _this.handleSearchFilter()
    }
    if (((event.key === "Backspace") || (event.key === "Delete")) && _state.search.length === 0) {
      _this.handleSearchFilter()
    }
  }

  handleSearchFilter = () => {
    const _this = this;
    const _state = _this.state
    let newState = Object.assign({}, _state);
    let tags = []
    tags = _this.finalData(_state.search, _state.filters);
    newState.tagList = tags
    if (_state.search.length === 0) {
      _this.setState({ tagList: tags, searchFilter: false });
    } else {
      _this.setState({ tagList: tags, searchFilter: true });
    }
  }

  submitHandler(e) {
    e.preventDefault();
  }

  render() {
    const _this = this;
    const _props = _this.props
    const _state = _this.state
    window.onresize = this.resize;
    const { filter, search, searchFilter, tagList } = _state;
    let data = _props.data;
    if (filter || searchFilter) {
      data = tagList
    }
    const length = data.length;
    if (filter || searchFilter || length > 0) {
      return (
        <div>
          <Form onSubmit={_this.submitHandler}>
            <FormGroup row>
              <div className="col-md-12" style={{ paddingTop: '6px' }}>
                <InputGroup>
                  <Input placeholder="Cari berasarkan ID atau nama" value={search}
                    onChange={_this.handleChange} onKeyUp={_this.handleKeyUp} type="text" step="1" />
                  <InputGroupAddon addonType="append"><ButtonReact onClick={_this.handleSearchFilter}>
                    <IconSearch size={16} /></ButtonReact></InputGroupAddon>
                </InputGroup>
              </div>
            </FormGroup>
            {length > 0 ?
              <SizeMe>{({ size }) =>
                < div className="table-responsive">
                  <TagListTableWR data={data} tableSize={size} on_click={_props.handleAdd} />
                </div>
              }</SizeMe>
              :
              <div className="col-md-12" style={{ paddingTop: '6px' }}>
                <div style={{ textAlign: 'center', fontWeight: 'bold' }}>Oopss... penanda tidak ditemukan</div>
              </div>
            }
          </Form>
        </div>
      )
    } else {
      return (
        <div>
          <Form onSubmit={_this.submitHandler}>
            <FormGroup row>
              <div className="col-md-12" style={{ paddingTop: '6px' }}>
                <div style={{ textAlign: 'center', fontWeight: 'bold' }}>Oopss... Penanda Masih Kosong</div>
                <div style={{ textAlign: 'center' }}>Penanda yang telah didaftarkan akan ditampilkan disini.</div>
              </div>
            </FormGroup>
          </Form>
        </div>
      )
    }
  }
}

const TagListTableWR = withRouter(TagTable);

class Tags extends IoteraClass {
  constructor(props) {
    super(props);
    this.state = {
      tags: [],
      loading: true,
      openDef: false,
      valueDef: '',
      valueDefLc: '',
      selectedPrefixDef: '',
    }
    this.handleAdd = this.handleAdd.bind(this);
  }

  componentDidMount() {
    const _this = this;
    const _props = _this.props
    const dit = domainIsTenant(_props);
    // callback global
    setCallbackGlobal(_props)
    _props.wInitRequestCall(
      {
        wparam: { ...dit, path: "/service/web/tag/category/get" },
        wcallback: {
          started: function (id) {
            // TODO Loading
          },
          finished: function (id, result) {
            // TODO Loading
            _this.setState({
              loading: false,
              tags: safeDeepGetWithType(result, ['body', 'categories'], [])
            })
          },
        }
      }
    );
    _props.wSetConfig({
      single_config: {
        [ADD]: {
          wparam: {
            ...dit,
            method: "POST",
            path: "/service/web/tag/definition/add"
          },
          wcallback: {
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                if (responseResult === Result.SUCCESS) {
                  _props.showSingleNotification({ message: 'Tambah Pilihan Penanda Sukses', level: 'success' });
                  _props.wSingleRequestCall({
                    id: RELOAD,
                  })
                  return;
                }
              } else if (result.code === Result.HTTP.BAD_REQUEST) {
                const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                if (responseResult === -4) {
                  _props.showSingleNotification({ message: 'Pilihan sudah terdaftar!', position: 'tr', level: 'error' });
                  _this.setState({
                    loading: false
                  })
                  return;
                }

              }
              _this.setState({
                loading: false,
              })
              _props.showSingleNotification({ message: 'Tambah Pilihan Penanda Gagal', position: 'tr', level: 'error' });
            }
          }
        },
        [RELOAD]: {
          wparam: { ...dit, path: "/service/web/tag/category/get" },
          wcallback: {
            started: function (id) {
              // TODO Loading
              _this.setState({
                loading: true
              })
            },
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                if (responseResult === Result.SUCCESS) {
                  _this.setState({
                    loading: false,
                    tags: safeDeepGetWithType(result, ['body', 'categories'], _props.items)
                  })
                  return;
                }
              }
              _this.setState({
                loading: false,
              })
            }
          }
        }
      }
    });
  }

  componentWillUnmount() {
    // callback global
    unsetCallbackGlobal(this.props)
  }

  handleClose = () => {
    this.setState({ openDef: false, valueDef: '', selectedPrefixDef: '' });
  };

  handleChangeDef = event => {
    this.setState({ valueDef: event.target.value })
  }

  handleChangeDefPref = event => {
    this.setState({ valueDefLc: event.target.value })
  }

  handleAdd = (prefix, cat) => {
    const _this = this;
    const _props = _this.props
    if (cat !== TAG_CAT_SINGLE_SELECTION) {
      _props.showSingleNotification({ message: 'Fitur tidak ada untuk penanda dengan tipe ini', position: 'tr', level: 'error' });
      return;
    }
    _this.setState({ openDef: true, selectedPrefixDef: prefix });
  }

  handleSubmit = () => {
    const _this = this;
    const _props = _this.props
    const _state = _this.state
    let prefix = _state.selectedPrefixDef;
    let name = _state.valueDef;
    let name_lc = _state.valueDefLc;
    if (name_lc !== '') {
      if (isContainUppercase(name_lc)) {
        _props.showSingleNotification({ message: 'Kunci penanda tidak boleh mengandung huruf besar!', level: 'error' });
        _this.setState({ openDef: false });
        return;
      } else if (hasWhiteSpace(name_lc)) {
        _props.showSingleNotification({ message: 'Kunci penanda tidak boleh mengandung spasi!', level: 'error' });
        _this.setState({ openDef: false });
        return;
      }
    } else {
      name_lc = name.toLowerCase().replace(/ /g, "_");
    }
    _props.wSingleRequestCall({
      id: ADD,
      body: {
        name,
        prefix,
        name_lc
      }
    });
    _this.setState({ openDef: false, valueDef: '', selectedPrefixDef: '', loading: true });
  }

  componentWillReceiveProps(nextProps) {
    const _this = this;
    const _props = _this.props
    if (nextProps.location !== _props.location) {
      _this.setState({ prevPath: _props.location })
    }
  }

  render() {
    const _this = this;
    const _props = _this.props
    const _state = _this.state
    let { loading, tags } = _state;
    const spinner =
      <div className='centeringItem'>
        <ReactLoading type='bubbles' color='#000' />
      </div>
    return (
      <Loader show={loading} message={spinner} backgroundStyle={{ backgroundColor: '#ffffff', opacity: 0.3 }}>
        <div className="view">
          <SubViewHeader title='Penanda' subTitle='Seluruh penanda yang terdaftar di aplikasi ini.' />
          <div className="view-content-dashboard">
            <TagList data={tags} handleAdd={_this.handleAdd} />
            <Dialog
              open={_state.openDef}
              onClose={_this.handleClose}
              aria-labelledby="form-dialog-title"
            >
              <DialogTitle id="form-dialog-title">Tambah Pilihan Penanda</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  Masukkan pilihan baru yang akan ditambahkan pada penanda ini.
                </DialogContentText>
                <TextField
                  autoFocus
                  margin="dense"
                  id="name"
                  label="Pilihan Baru"
                  fullWidth
                  onChange={_this.handleChangeDef}
                />
                <TextField
                  margin="dense"
                  id="name"
                  label="Kata Kunci Pilihan (opsional)"
                  fullWidth
                  onChange={_this.handleChangeDefPref}
                />
              </DialogContent>
              <DialogActions>
                <Button onClick={_this.handleClose} color="primary">
                  Batal
            </Button>
                <Button onClick={_this.handleSubmit} variant="contained" color="primary">
                  Tambah
            </Button>
              </DialogActions>
            </Dialog>
            <Tooltip TransitionComponent={Zoom} title='Tambah Role' enterDelay={500} >
              <Fab variant="extended" color={'primary'} style={{
                position: 'absolute',
                bottom: 0 * 2,
                right: 20 * 2
              }}
                onClick={(e) => _props.history.push('.' + S + '_tag_add_')}
              >
                <AddIcon style={{ marginRight: 8 }} />
                Penanda Baru
              </Fab>
            </Tooltip>
          </div>
        </div>
      </Loader >
    )
  }
}

const TagsWR = withRouter(Tags);

const mapStateToProps = (state) => ({
  items: wSelector.getSoleInitMappedRPayload(state, 'categories')
})

const mapDispatchToProps = (dispatch) => ({
  ...wBoundActions(dispatch),
  ...bindActionCreators(notificationActions, dispatch),
  ...bindActionCreators(modalActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(TagsWR);
